// QuestionsCompressImg.js

// Helper de compresión de imágenes usado por QuestionImageUploadInner (Questions.jsx).
// Redimensiona la imagen para que su lado mayor no exceda `maxDimension`,
// la dibuja sobre un canvas con fondo blanco y devuelve un Blob JPEG comprimido.

export const compressQuestionImage = (file, maxDimension = 300) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      let { width, height } = img;
      if (width > maxDimension || height > maxDimension) {
        if (width > height) {
          width  = maxDimension;
          height = Math.round((maxDimension * img.height) / img.width);
        } else {
          height = maxDimension;
          width  = Math.round((maxDimension * img.width) / img.height);
        }
      }
      const canvas = document.createElement('canvas');
      canvas.width  = Math.max(1, width);
      canvas.height = Math.max(1, height);
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(
        (blob) => blob ? resolve(blob) : reject(new Error('No se pudo comprimir')),
        'image/jpeg',
        0.88,
      );
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Error al leer imagen')); };
    img.src = url;
  });

export default compressQuestionImage;